import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
Vue.use(Vuex)
const store = new Vuex.Store({
    state: {
        baiduMapFrom:{},
        imUnreaded: false,
        imChatid: '',
        imToken: '',
        imJobid: 0,
        LoginOrNot: false, // 用户是否登录
        LoginType: 0, // 用户类型-1为企业 2位个人
        userToken: 'user_token',
        userMobile: '',
        sendSmsInterval: 60, // 发送验证码间隔时间，以秒为单位
        sendSmsBtnText: '获取验证码',
        sendSmsBtnTextColor: '#1787fb',
        sendSmsBtnDisabled: false,
        sendEmailInterval: 60, // 发送验证码间隔时间，以秒为单位
        sendEmailBtnText: '获取验证码',
        sendEmailBtnTextColor: '#1787fb',
        sendEmailBtnDisabled: false,
        sendSmsTimer: '',
        sendSmsMessage: '',
        sendEmailTimer: '',
        sendEmailMessage: '',
        minWage: 500,
        maxWage: 50000,
        minAge: 16,
        maxAge: 65,
        classifyEdu: '',
        classifyWage: '',
        classifyAge: '',
        classifyCurrent: '',
        classifyJobCategory: '',
        classifyCityCategory: '',
        classifyCityOriginal: '',
        classifyMajor: '',
        classifyMajorOriginal: '',
        classifyMarriage: '',
        classifyResumeNature: '',
        classifyTrade: '',
        classifyLanguage: '',
        classifyLanguageLevel: '',
        classifyResumeTag: '',
        classifyJobTag: '',
        classifyJobNature: '',
        classifyExperience: '',
        classifyCompanyNature: '',
        classifyCompanyScale: '',
        classifyFeedback: '',
        classifyResumeStrongTag: '',
        classifyTipoffJob: '',
        classifyTipoffResume: '',
        resume: {
            module_list: {},
            field_rule: {},
            basic: {},
            contact: {},
            intention_list: [],
            work_list: [],
            education_list: [],
            project_list: [],
            training_list: [],
            language_list: [],
            certificate_list: [],
            img_list: []
        },
        config: '',
        dropdownSettrOption: [
            { text: '不限', value: 0 },
            { text: '3天内', value: 3 },
            { text: '7天内', value: 7 },
            { text: '15天内', value: 15 },
            { text: '30天内', value: 30 }
        ],
        userIminfo: {
            userid: '',
            user_token: ''
        },

        userPoints: 0,
        userSignin: false
    },
    mutations: {
    },
    actions: {

    },
    modules: {},
    getters: {},
    plugins: []
})
export default store



// WEBPACK FOOTER //
// ./src/store/index.js